/**
 * 错误码定义
 * 统一项目中的错误码，便于追踪和定位问题
 */

// 错误来源分类
export const ERROR_SOURCE = {
  SDK: 'SDK',           // TIM/TRTC SDK 错误
  NETWORK: 'NETWORK',   // 网络请求错误
  BUSINESS: 'BUSINESS', // 业务逻辑错误
  SYSTEM: 'SYSTEM'     // 系统级错误
}

// SDK 错误码 (TIM/TRTC)
export const SDK_ERRORS = {
  // TIM SDK 错误
  TIM_NOT_INIT: { code: 'TIM_001', message: 'TIM SDK 未初始化', source: 'SDK' },
  TIM_NOT_READY: { code: 'TIM_002', message: 'TIM SDK 未就绪', source: 'SDK' },
  TIM_LOGIN_FAILED: { code: 'TIM_003', message: 'TIM 登录失败', source: 'SDK' },
  TIM_LOGOUT_FAILED: { code: 'TIM_004', message: 'TIM 登出失败', source: 'SDK' },
  TIM_SEND_MSG_FAILED: { code: 'TIM_005', message: '发送消息失败', source: 'SDK' },
  TIM_GET_MSG_FAILED: { code: 'TIM_006', message: '获取消息列表失败', source: 'SDK' },
  TIM_CREATE_MSG_FAILED: { code: 'TIM_007', message: '创建消息失败', source: 'SDK' },
  TIM_INVALID_CONVERSATION: { code: 'TIM_008', message: '无效的会话ID', source: 'SDK' },

  // TRTC SDK 错误
  TRTC_NOT_INIT: { code: 'TRTC_001', message: 'TRTC SDK 未初始化', source: 'SDK' },
  TRTC_JOIN_FAILED: { code: 'TRTC_002', message: '加入通话失败', source: 'SDK' },
  TRTC_LEAVE_FAILED: { code: 'TRTC_003', message: '离开通话失败', source: 'SDK' },
  TRTC_START_FAILED: { code: 'TRTC_004', message: '开始通话失败', source: 'SDK' },
  TRTC_STOP_FAILED: { code: 'TRTC_005', message: '结束通话失败', source: 'SDK' },

  // 网络错误
  NETWORK_ERROR: { code: 'NET_001', message: '网络请求失败', source: 'NETWORK' },
  NETWORK_TIMEOUT: { code: 'NET_002', message: '请求超时', source: 'NETWORK' },
  NETWORK_OFFLINE: { code: 'NET_003', message: '网络连接已断开', source: 'NETWORK' },

  // 业务错误
  BIZ_AUTH_FAILED: { code: 'BIZ_001', message: '认证失败，请重新登录', source: 'BUSINESS' },
  BIZ_PERMISSION_DENIED: { code: 'BIZ_002', message: '无权限操作', source: 'BUSINESS' },
  BIZ_INVALID_PARAMS: { code: 'BIZ_003', message: '参数错误', source: 'BUSINESS' },
  BIZ_NOT_FOUND: { code: 'BIZ_004', message: '资源不存在', source: 'BUSINESS' },
  BIZ_SERVER_ERROR: { code: 'BIZ_005', message: '服务器错误', source: 'BUSINESS' },

  // 系统错误
  SYS_UNSUPPORTED: { code: 'SYS_001', message: '浏览器不支持该功能', source: 'SYSTEM' },
  SYS_STORAGE_ERROR: { code: 'SYS_002', message: '存储操作失败', source: 'SYSTEM' },
  SYS_UNKNOWN: { code: 'SYS_999', message: '未知错误', source: 'SYSTEM' }
}

// TIM SDK 原始错误码映射
export const TIM_ERROR_CODES = {
  10002: 'TIM_003',  // 无效的 UserSig
  10003: 'TIM_003',  // UserSig 过期
  10004: 'BIZ_001',  // 签名验证失败
  10007: 'BIZ_PERMISSION_DENIED',  // 权限不足
  10009: 'BIZ_PERMISSION_DENIED',  // 管理员禁止操作
  20001: 'TIM_NOT_READY',  // SDK 未初始化
  20003: 'TIM_INVALID_CONVERSATION',  // 会话不存在
  20006: 'TIM_SEND_MSG_FAILED',  // 发送消息失败
  60001: 'SYS_OFFLINE',  // 被踢出
}

// 根据 TIM 错误码获取错误定义
export function getTIMError(error) {
  const code = error?.code || error?.ErrorCode
  const mappedCode = TIM_ERROR_CODES[code]
  if (mappedCode && SDK_ERRORS[mappedCode]) {
    return SDK_ERRORS[mappedCode]
  }
  return SDK_ERRORS.SYS_UNKNOWN
}

export default {
  ERROR_SOURCE,
  SDK_ERRORS,
  TIM_ERROR_CODES,
  getTIMError
}
